<template>
  <v-text-field
    v-model="colorValue"
    label="Цвет фона"
    dense
    outlined
    hide-details="auto"
    :rules="[colorRule]"
    placeholder="#FFFFFF"
    class="flex-grow-1 mt-4"
    @input="validateAndNormalize"
  >
    <template v-slot:append>
      <div
        :style="{
          backgroundColor: isValidColor ? value : '#FFFFFF',
          width: '24px',
          height: '24px',
          borderRadius: '4px',
          border: '1px solid rgba(0, 0, 0, 0.24)',
          marginTop: '-2px'
        }"
      ></div>
    </template>
  </v-text-field>
</template>

<script>
  export default {
    name: 'TextFieldColor',
    components: {},
    computed: {},
    props: {
      value: String
    },
    data: () => {
      return {
        colorValue: '#FFFFFF'
      }
    },
    computed: {
      isValidColor() {
        return this.checkColor(this.colorValue)
      }
    },
    watch: {
      colorValue(newValue) {
        if (this.isValidColor) {
          this.$emit('input', newValue)
        }
      }
    },
    methods: {
      checkColor(color) {
        const hexRegex = /^#([A-Fa-f0-9]{3}|[A-Fa-f0-9]{6})$/
        return hexRegex.test(color)
      },
      colorRule(value) {
        return this.checkColor(value) || 'Некорректный формат (например, #FFFFFF)'
      },
      validateAndNormalize(val) {
        if (val && !val.startsWith('#')) {
          this.colorValue = '#' + val
        }
      }
    },
    mounted() {
      this.colorValue = this.value || '#FFFFFF'
    }
  }
</script>
